import { Routes } from '@angular/router';
import { BillPageComponent } from './pages/bill-page/bill-page.component';
import { QuotationPageComponent } from './pages/quotation-page/quotation-page.component';
import { PurchasePageComponent } from './pages/purchase-page/purchase-page.component';
import { ProviderPageComponent } from './pages/provider-page/provider-page/provider-page.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'register',
    pathMatch: 'full'
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register-page/register.routes'),
  },
  {
    path: 'provider',
    component: ProviderPageComponent
    
  }, 
  {
    path: 'bill',
    component: BillPageComponent
  },
  {
    path: 'quotation',
    component: QuotationPageComponent
  },
  {
    path: 'purchase',
    component: PurchasePageComponent
  }, 
  {
    path: '**',
    redirectTo: 'register'
  }
];

